import { Injectable } from '@angular/core';
import { TranslateService } from '../../../api/translate.service';
import { 
  fieldAddressLine1Col, 
  fieldAmountCol, 
  fieldCounterPartyCol, 
  fieldCustomerNameCol, 
  fieldDateCol, 
  fieldIdCol, 
  fieldInvoiceIdCol, 
  fieldIpMetroCol, 
  fieldOpportunityCol, 
  fieldPercentageCol, 
  fieldPrimaryEmployeeFunctionalUnitCol, 
  fieldPrimaryEmployeeFunctionalUnitIdCol, 
  fieldPrimaryEmployeeIdCol, 
  fieldPrimaryEmployeeManagingOfficeCol, 
  fieldPrimaryEmployeeManagingOfficeIdCol, 
  fieldPrimaryEmployeeNameCol, 
  fieldPropertyAreaCol, 
  fieldPropertyBaseIdCol, 
  fieldSellerNameCol, 
  fieldSizeAreaMeasureCol, 
  fieldTransactionTypeCol
} from '../../../utils/ag-grid/column-defs';
import { ColDef } from 'ag-grid-community';

@Injectable({
    providedIn: 'root'
  })
export class YTDSummaryFinanceReportService {

  constructor(private translateService: TranslateService) { }

  getHeaders(settings: { middle: any, left: any, right: any }) {
    return [
      {
        header: this.translateService.getTranslation('FINISHLINE_ID'),
        key: 'finishline_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INVOICE_ID'),
        key: 'invoice_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INVOICE_DT'),
        key: 'invoice_date',
        width: 30,
        style: { ...settings.middle },
      },
      // Deal Info Section
      {
        header: this.translateService.getTranslation('TRANSACTION_TYPE'),
        key: 'transaction_type',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_ID'),
        key: 'opportunity',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('BILL_TO_CUST'),
        key: 'bill_to_customer_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('OTHER_PARTY'),
        key: 'other_party',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('ADDRESS_LINE1'),
        key: 'address_line1',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PROPERTY_SIZE'),
        key: 'size',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('SIZE_MEASUREMENT'),
        key: 'uom',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('SALE_LEASE_VALUE'),
        key: 'sale_lease_value',
        width: 30,
        style: { ...settings.middle }
      },
      // Producer Info Section
      {
        header: this.translateService.getTranslation('PRODUCER_BROKER_EMPID'),
        key: 'producer_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRODUCER_BROKER_NAME'),
        key: 'producer_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRODUCER_FUNCTIONAL_UNIT'),
        key: 'functional_unit_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRODUCER_FUNCTIONAL_UNIT_DESCRIPTION'),
        key: 'functional_unit_description',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRODUCER_MANAGING_OFFICE'),
        key: 'managing_office_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRODUCER_MANAGING_OFFICE_DESCRIPTION'),
        key: 'managing_office_description',
        width: 30,
        style: { ...settings.middle },
      },
      // Fees Section
      {
        header: this.translateService.getTranslation('PERCENT_OUTPUT'),
        key: 'producer_percent',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CBRE_FEE_$'),
        key: 'cbre_fee_total',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CBRE_REVENUE_FUMO'),
        key: 'cbre_revenue_fumo_balance',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CBRE_BROKER_ACTUAL_FEE'),
        key: 'cbre_broker_actual_fee',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('DISBURSEMENT_ALLOC_AMT'),
        key: 'disbursement_amount',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('SMF_AMOUNT'),
        key: 'smf',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('AKOL_DED'),
        key: 'deduction',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CONJUNCTIONAL_AGENT_ACTUAL_FEE'),
        key: 'conjunctional_agent_actual_fee',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('SELLER_NAME'),
        key: 'seller_name', 
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PROPERTY_BASE_ID'),
        key: 'property_base_id',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('IP_METRO'), 
        key: 'ip_metro', 
        width: 30,
        style: { ...settings.middle }
      },
    ];
  }

  getDataSourceSettings(): ColDef[] {
    return [
      {
        ...fieldIdCol,
        field: 'finishline_id',
        headerName: this.translateService.getTranslation('FINISHLINE_ID'),
      }, 
      {
        ...fieldInvoiceIdCol,
        field: 'invoice_id',
        headerName: this.translateService.getTranslation('INVOICE_ID'),
        cellRenderer: null,
      },      
      {
        ...fieldDateCol,
        field: 'invoice_date',
        headerName: this.translateService.getTranslation('INVOICE_DT'),
      },       
      {
        ...fieldTransactionTypeCol,
        headerName: this.translateService.getTranslation('TRANSACTION_TYPE'),
      },       
      {
        ...fieldOpportunityCol,
        minWidth: 250,
        headerName: this.translateService.getTranslation('OPPORTUNITY'),
      },      
      {
        ...fieldCustomerNameCol,
        field: 'bill_to_customer_name',
        minWidth: 250,
        headerName: this.translateService.getTranslation('BILL_TO_CUST'),
      },       
      {
        ...fieldCounterPartyCol,
        field: 'other_party',
        headerName: this.translateService.getTranslation('OTHER_PARTY'),
      },      
      {
        ...fieldAddressLine1Col,
        headerName: this.translateService.getTranslation('ADDRESS_LINE1'),
      },     
      {
        ...fieldPropertyAreaCol,
        field: 'size',
        headerName: this.translateService.getTranslation('PROPERTY_AREA'),
      },      
      {
        ...fieldSizeAreaMeasureCol,
        field: 'uom',
        headerName: this.translateService.getTranslation('SIZE_MEASUREMENT'),
      },
      {
        ...fieldAmountCol,
        field: 'sale_lease_value',
        headerName: this.translateService.getTranslation('SALE_LEASE_VALUE'),
      },      
      {
        ...fieldPrimaryEmployeeIdCol,
        field: 'producer_id',
        headerName: this.translateService.getTranslation('PRODUCER_BROKER_EMPID'),
        minWidth: 220,
      },      
      {
        ...fieldPrimaryEmployeeNameCol,
        field: 'producer_name',
        headerName: this.translateService.getTranslation('PRODUCER_BROKER_NAME'),
      },   
      {
        ...fieldPrimaryEmployeeFunctionalUnitIdCol,
        field: 'functional_unit_id',
        headerName: this.translateService.getTranslation('PRODUCER_FUNCTIONAL_UNIT'),
      },    
      {
        ...fieldPrimaryEmployeeFunctionalUnitCol,
        field: 'functional_unit_description',
        headerName: this.translateService.getTranslation('PRODUCER_FUNCTIONAL_UNIT_DESCRIPTION'),
      },            
      {
        ...fieldPrimaryEmployeeManagingOfficeIdCol,
        field: 'managing_office_id',
        headerName: this.translateService.getTranslation('PRODUCER_MANAGING_OFFICE'),
      },
      {
        ...fieldPrimaryEmployeeManagingOfficeCol,
        field: 'managing_office_description',
        headerName: this.translateService.getTranslation('PRODUCER_MANAGING_OFFICE_DESCRIPTION'),
      },   
      {
        ...fieldPercentageCol,
        field: 'producer_percent',
        headerName: this.translateService.getTranslation('PERCENT_OUTPUT'),
        minWidth: 200,
      },
      {
        ...fieldAmountCol,
        field: 'cbre_fee_total',
        headerName: this.translateService.getTranslation('CBRE_FEE_$'),
      }, 
      {
        ...fieldAmountCol,
        field: 'cbre_revenue_fumo_balance',
        headerName: this.translateService.getTranslation('CBRE_REVENUE_FUMO'),
        minWidth: 270,
      },
      {
        ...fieldAmountCol,
        field: 'cbre_broker_actual_fee',
        headerName: this.translateService.getTranslation('CBRE_BROKER_ACTUAL_FEE'),
        minWidth: 250,
      },
      {
        ...fieldAmountCol,
        field: 'disbursement_amount',
        headerName: this.translateService.getTranslation('DISBURSEMENT_ALLOC_AMT'),
        minWidth: 250,
      },
      {
        ...fieldAmountCol,
        field: 'smf',
        headerName: this.translateService.getTranslation('SMF_AMOUNT'),
      },
      {
        ...fieldAmountCol,
        field: 'deduction',
        headerName: this.translateService.getTranslation('AKOL_DED'),
      },
      {
        ...fieldAmountCol,
        field: 'conjunctional_agent_actual_fee',
        headerName: this.translateService.getTranslation('CONJUNCTIONAL_AGENT_ACTUAL_FEE'),
        minWidth: 290,
      },
      {
        ...fieldSellerNameCol,
        headerName: this.translateService.getTranslation('SELLER_NAME'),
      },
      {
        ...fieldPropertyBaseIdCol,
        headerName: this.translateService.getTranslation('PROPERTY_BASE_ID'),
      },
      {
        ...fieldIpMetroCol,
        headerName: this.translateService.getTranslation('IP_METRO'),
      },
    ];
  }
}